<div class="container my-5">
  <div class="row justify-content-center">
    <h1 class="card-title text-center mb-5">Change Password</h1>
    <div class="col-md-6">
      <div class="card shadow-lg border-0 rounded-3">
        <div class="card-body p-4">
          <div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
  {{ message }}
</div>

          <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
            <!-- Existing Password -->
            <div class="mb-3">
              <label for="existingPassword" class="form-label">Existing Password</label>
              <input 
                type="password" 
                class="form-control" 
                id="existingPassword" 
                placeholder="Enter your current password" 
                formControlName="existingPassword"
              />
            </div>

            <!-- New Password -->
            <div class="mb-3">
              <label for="newPassword" class="form-label">New Password</label>
              <input 
                type="password" 
                class="form-control" 
                id="newPassword" 
                placeholder="Enter a new password"
                formControlName="newPassword"
              />
              <div class="text-danger mt-1" *ngIf="passwordForm.get('newPassword')?.touched && newPasswordErrors">
                {{ newPasswordErrors }}
              </div>
            </div>


            <!-- Submit Button -->
            <div class="d-grid">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-lock-fill me-2"></i> Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>